import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Group } from 'utils';

type ReturnType = Promise<AxiosResponse<{ status: string }>>;

interface ConfirmImportPayload {
    import_token: string;
    action: 'skip_duplicates' | 'cancel';
    skip_rows?: number[];
}

const confirmMemberImport = (group: Group, payload: ConfirmImportPayload): ReturnType => {
    return Request.post(`/imports/group/members/${group.uuid}/confirm`, payload);
};

export default confirmMemberImport;
